<template>
    <div :style="cssProps">
        <div class="header-mobile">
            <div @click="openMenu" :class="['nav-icon', { open: show }]" v-on-clickaway="closeMenu">
                <div></div>
            </div>
            <div
                class="logo"
                v-smooth-scroll="{ duration: 1000, updateHistory: false, offset: -150 }"
                href="#call-to-action"
            >
                <a>
                    <img :src="logo" alt="Engelink" />
                </a>
            </div>
        </div>
        <div class="nav-mobile" :class="{ show: show }">
            <ul>
                <li v-for="(item, index) in links" :key="index">
                    <a :href="item.path" v-smooth-scroll="{ duration: 1000, updateHistory: false, offset: -75 }">{{
                        item.label
                    }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
export default {
    name: 'mobileComponent',
    mixins: [clickaway],
    props: {
        links: {
            type: Array,
            default: () => {
                return [];
            }
        },
        topOfPage: {
            type: Boolean,
            desktop: true
        }
    },
    data() {
        return {
            show: false
        };
    },
    methods: {
        closeMenu() {
            this.show = false;
            this.$emit('setTransparent');
        },
        openMenu() {
            this.show = !this.show;
            this.$emit('setWhite');
        },
        openLink(url) {
            window.open(url);
        }
    },
    computed: {
        logo() {
            if (this.show) {
                return require('@/assets/images/logo_engelink_credito.svg');
            } else {
                return require(`@/assets/images/${
                    this.topOfPage ? 'logo_engelink_credito_negativa.svg' : 'logo_engelink_credito.svg'
                }`);
            }
        },
        cssProps() {
            return {
                '--menuColor': this.topOfPage ? '#fff' : '#003f7e',
                '--bgColor': this.show ? '#fff' : 'transparent'
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.header-mobile {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    padding: 16px;
    background: var(--bgColor);
    .logo {
        display: flex;
        justify-content: center;
        align-items: center;
        a {
            display: flex;
            align-items: center;
            img {
                height: 44px;
            }
        }
    }
}
.nav-mobile {
    text-align: justify;
    position: fixed;
    height: 100%;
    width: 0%;
    background-color: #fff;
    color: #000;
    transition: 0.5s;
    overflow: hidden;
    top: 76px;
    left: 0px;
    li {
        font-family: 'Open Sans', sans-serif;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        margin-bottom: 16px;
        text-transform: uppercase;
        cursor: pointer;
        a {
            color: #000;
        }
    }
}
.nav-mobile.show {
    box-shadow: inset 0px 3px 6px #00000030, 200px 0px 0px #00000075;
    width: 80%;
    padding: 16px;
}
.header-mobile .nav-icon:before {
    width: 35px;
}
.header-mobile .nav-icon {
    top: 13px;
    left: 2%;
    width: 30px;
    align-self: center;
}
.header-mobile .nav-icon:after {
    width: 25px;
}
.header-mobile .nav-icon:after,
.header-mobile .nav-icon:before,
.header-mobile .nav-icon div {
    background-color: var(--menuColor);
    border-radius: 3px;
    content: '';
    display: block;
    height: 4px;
    margin: 4px 0;
    transition: all 0.4s ease-in-out;
}
.header-mobile .nav-icon.open:after,
.header-mobile .nav-icon.open:before,
.header-mobile .nav-icon.open div {
    background-color: #003f7e;
}
.header-mobile .nav-icon.open:after,
.header-mobile .nav-icon.open:before,
.header-mobile .nav-icon.open {
    width: 20px !important;
    padding-left: 0px !important;
}
.header-mobile .nav-icon.open:before {
    transform: translateY(7px) rotate(135deg);
}

.header-mobile .nav-icon.open:after {
    transform: translateY(-9px) rotate(-135deg);
}

.header-mobile .nav-icon.open div {
    transform: scale(0);
}
</style>
